import { SupplierOrigin } from '../../interfaces/Supplier/Supplier'
import { supplierOriginActionsTypes } from '../types/supplierOriginActionsTypes'

export type OriginAction = SupplierOriginAction | SuppliersOriginActionAsync

// Esto va a REDUX
export interface SupplierOriginAction {
  type: typeof supplierOriginActionsTypes.GET_SUPPLIERS_ORIGIN_EXITO
  suppliersOrigin: SupplierOrigin[] | undefined
  error: string | undefined
}

export const getSuppliersAction = (
  suppliersOrigin?: SupplierOrigin[],
  error?: string
): SupplierOriginAction => {
  return {
    type: supplierOriginActionsTypes.GET_SUPPLIERS_ORIGIN_EXITO,
    suppliersOrigin,
    error
  }
}

// Esto va a SAGA
export interface SuppliersOriginActionAsync {
  type: typeof supplierOriginActionsTypes.GET_SUPPLIERS_ORIGIN
}

export const getSuppliersActionAsync = (): SuppliersOriginActionAsync => {
  return {
    type: supplierOriginActionsTypes.GET_SUPPLIERS_ORIGIN
  }
}
